export const SECTION_ID = {
  amenities: "amenities",
  about: "about",
  reviews: "reviews",
  rooms: "rooms",
} as const;
